import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
    Alert,
    Button, CardMedia,
    Checkbox,
    Dialog, DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    FormControlLabel,
    IconButton, Radio, RadioGroup,
    Select, Step, StepContent, StepLabel, Stepper
} from "@mui/material";
import LicencePlateInput from "./LicencePlateInput";
import {useEffect, useState} from "react";
import CloseIcon from '@mui/icons-material/Close';
import TermsOfUse from './TermsOfUse';
import PrivacyPolicy from "./PrivacyPolicy";


const theme = createTheme();

export interface ILicencePlateInput {
    licencePlate?: string
    licencePlateCountry?: string
    licencePlateOwnerEmail?: string
    licencePlateOwner?: string
    licencePlateOwnerPhone ?: string
}

export default function FormPage() {
    const [licencePlatesList, setLicencePlatesList] = useState<ILicencePlateInput[]>([{licencePlate: undefined, licencePlateCountry: 'rus'}])

    const [isInvalidNestedForm, setInvalidNestedForm] = useState(false);
    const [isInvalidForm, setInvalidForm] = useState(false);


    const [isOpenRecommendations, setOpenRecommendations] = useState(false);
    const [isOpenHowItWorks, setOpenHowItWorks] = useState(false);

    const [isOpenTermsOfUse, setOpenTermsOfUse] = useState(false);
    const [isOpenPrivacyPolicy, setOpenPrivacyPolicy] = useState(false);

    const [isAcceptTermsAndPrivacy, setAcceptTermsAndPrivacy] = useState(false);

    const [createdApartmentNumber, setCratedApartmentNumber] = useState<string>('');
    const [createdUnlivedNumber, setCratedUnlivedNumber] = useState<string>('');
    const [createdParkingPlaceNumber, setCratedParkingPlaceNumber] = useState<string>('');

    const [createdComment, setCratedComment] = useState<string>('');

    const [createType, setCreateType] = useState<string>('2');

    const [isSending, setSending] = useState(false);

    useEffect(()=>{
        if (createType == '0'){
            if (createdApartmentNumber.length === 0){
                setInvalidForm(true);
            } else {
                setInvalidForm(false);
            }
        } else if (createType == '1'){
            if (createdUnlivedNumber.length === 0){
                setInvalidForm(true);
            } else {
                setInvalidForm(false);
            }
        } else {
            if (createdParkingPlaceNumber.length === 0){
                setInvalidForm(true);
            } else {
                setInvalidForm(false);
            }
        }
    }, [createdApartmentNumber, createdUnlivedNumber, createType, createdParkingPlaceNumber]);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        console.log(licencePlatesList)
        setSending(true);
        fetch('//kamenka.megaqr.ru/api/statement', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({apartmentNumber: createdApartmentNumber, unlivedNumber: createdUnlivedNumber, parkingPlaceNumber: createdParkingPlaceNumber, licencePlatesList: licencePlatesList, comment: createdComment}),
            credentials: "include"
        })
            .then(async response => {
                console.log(response)
                setSending(false);
                if (response.ok){
                    const b = await response.json()
                    window.location.href = `statement/${b.id}`
                }


            })
            .catch(error => {

                console.error('There was an error!', error);
            });
    };

    return (
        <ThemeProvider theme={theme}>
            <Grid container component="main" sx={{ height: '100vh' }}>
                <CssBaseline />
                <Grid
                    item
                    xs={false}
                    sm={4}
                    md={7}
                    sx={{
                        backgroundImage: 'url(/background.jpg)',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                />
                <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            my: 2,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >

                        <Alert severity="warning" sx={{ mt: 1}} onClick={()=>{
                            setOpenRecommendations(true);
                        }}>
                            <u>Рекомендации по заполнению акнкеты</u>
                        </Alert>

                        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={createType}
                                onChange={(e)=>{
                                    setCreateType(e.target.value)
                                }}
                            >
                                <FormControlLabel value="1" control={<Radio />} label="Нежилое помещение" />
                                <FormControlLabel value="2" control={<Radio />} label="Парковочное место" />
                            </RadioGroup>

                            {
                                createType == '0' ?
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        type="number"
                                        error={createdApartmentNumber.length === 0}
                                        value={createdApartmentNumber}
                                        onChange={(event) => {
                                            setCratedApartmentNumber(event.target.value)
                                        }}
                                        label="Номер квартиры"
                                        name="apartment"
                                    />
                                    :  createType == '1' ?
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        type="number"
                                        error={createdUnlivedNumber.length === 0}
                                        value={createdUnlivedNumber}
                                        onChange={(event) => {
                                            setCratedUnlivedNumber(event.target.value ? parseInt(event.target.value).toString(): '')
                                        }}
                                        label="Номер помещения (без буквы Н)"
                                        name="unlived"
                                    />
                                    :
                                    <TextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        type="number"
                                        error={createdParkingPlaceNumber.length === 0}
                                        value={createdParkingPlaceNumber}
                                        onChange={(event) => {
                                            setCratedParkingPlaceNumber(event.target.value ? parseInt(event.target.value).toString(): '')
                                        }}
                                        label="Номер парковочного места"
                                        name="parking-place"
                                    />
                            }
                            <TextField
                                fullWidth
                                multiline
                                rows={2}
                                type="text"
                                value={createdComment}
                                onChange={(event) => {
                                    setCratedComment(event.target.value)
                                }}
                                label="Комментарий"
                                name="comment"
                            />
                            <Typography variant="h6" sx={{mt: 1}}>
                                Номерные знаки
                            </Typography>
                            {licencePlatesList.map((r, i)=>(
                                <LicencePlateInput
                                    onRemove={()=>{
                                        const curList = [...licencePlatesList];
                                        curList.splice(i,1);
                                        setLicencePlatesList(curList);
                                    }}
                                    onLicencePlateCountryChange={(v: string)=>{
                                       licencePlatesList[i].licencePlateCountry = v;
                                       setLicencePlatesList(licencePlatesList);
                                    }}
                                    onLicencePlateChange={(v:string)=>{
                                       licencePlatesList[i].licencePlate = v;
                                       setLicencePlatesList(licencePlatesList);
                                    }}
                                    onLicencePlateEmailChange={(v:string)=>{
                                        licencePlatesList[i].licencePlateOwnerEmail = v;
                                        setLicencePlatesList(licencePlatesList);
                                    }}
                                    onLicencePlatePhoneChange={(v:string)=>{
                                        licencePlatesList[i].licencePlateOwnerPhone = v;
                                        setLicencePlatesList(licencePlatesList);
                                    }}
                                    onLicencePlateOwnerChange={(v:string)=>{
                                        licencePlatesList[i].licencePlateOwner = v;
                                        setLicencePlatesList(licencePlatesList);
                                    }}
                                    onInvalid={(v: boolean)=>{
                                        setInvalidNestedForm(v);
                                    }}
                                    isDeleted={licencePlatesList.length > 1}
                                    licencePlate={r.licencePlate}
                                    licencePlateCountry={r.licencePlateCountry}
                                    licencePlateEmail={r.licencePlateOwnerEmail}/>
                            ))}

                            <Button fullWidth color="primary" onClick={()=>{
                                setLicencePlatesList([...licencePlatesList, {licencePlate: undefined, licencePlateCountry: 'rus'}])
                            }}>Хочу добавить еще один номерной знак</Button>



                        <FormControlLabel
                            style={{ pointerEvents: "none" }}
                            sx={{ mt: 2}}
                            control={
                                <Checkbox style={{pointerEvents: "auto"}} onChange={(e)=>{
                                    setAcceptTermsAndPrivacy(e.target.checked)
                                }}/>
                            }
                            label={
                                <Typography>
                                    Я соглашаюсь с <Link onClick={()=>{setOpenTermsOfUse(true)}} style={{cursor: "pointer", pointerEvents: "auto"}}>Условиями использования</Link> и <Link onClick={()=>{setOpenPrivacyPolicy(true)}} style={{cursor: "pointer", pointerEvents: "auto"}}>Политикой конфиденциальности</Link>
                                </Typography>
                            }
                        />
                        <Button sx={{ mt: 2}} variant="contained" disabled={!isAcceptTermsAndPrivacy || isInvalidForm || isInvalidNestedForm || isSending} type="submit" fullWidth>Отправить заявку</Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Dialog
                fullScreen
                open={isOpenRecommendations}
                onClose={()=>{setOpenRecommendations(false)}}
            >
                <DialogTitle sx={{ my: 2, p: 2 }}>
                        <IconButton
                            aria-label="close"
                            onClick={()=>{setOpenRecommendations(false)}}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText >
                        <Stepper orientation="vertical" activeStep={-1}>
                            <Step>
                                <StepLabel>
                                    <Typography variant={"h6"}>
                                        Ознакомтесь с <Link onClick={()=>{setOpenTermsOfUse(true)}} style={{cursor: "pointer", pointerEvents: "auto"}}>Условиями использования</Link> и <Link onClick={()=>{setOpenPrivacyPolicy(true)}} style={{cursor: "pointer", pointerEvents: "auto"}}>Политикой конфиденциальности</Link>
                                    </Typography>
                                </StepLabel>
                            </Step>
                            <Step>
                                <StepLabel
                                    optional={
                                        <Typography>Номерной знак следует заполнять <b>латинскими буквами</b> (если номер введен корректно - рамка поля меняет цвет с красного на синий). Пример правильно заполненного поля приведен ниже. Для номерных знаков отличных от Российской Федерации в поле "Страна" следует выбрать нужную страну.
                                            <CardMedia
                                                component="img"
                                                image="/examples/ex-1.png"
                                                alt="Пример заполнения поля с номерным знаком"
                                            />
                                            </Typography>
                                    }>
                                    <Typography variant={"h6"} gutterBottom>
                                        Заполните форму
                                    </Typography>
                                </StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>
                                    <Typography variant={"h6"}>
                                        Отправьте заявление на рассмотрение
                                    </Typography>
                                </StepLabel>
                            </Step>
                            <Step>
                                <StepLabel>
                                    <Typography variant={"h6"}>
                                        Отслеживайте статус заявление по полученной ссылке
                                    </Typography>
                                </StepLabel>
                            </Step>
                        </Stepper>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
            <Dialog
                fullScreen
                open={isOpenTermsOfUse}
                onClose={()=>{setOpenTermsOfUse(false)}}>
                <DialogTitle sx={{ my: 2, p: 1 }}>
                    <Typography variant="h5"  component="div">
                        Условия использования
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={()=>{setOpenTermsOfUse(false)}}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TermsOfUse/>
                </DialogContent>
            </Dialog>
            <Dialog
                fullScreen
                open={isOpenPrivacyPolicy}
                onClose={()=>{setOpenPrivacyPolicy(false)}}>
                <DialogTitle sx={{ my: 2, p: 1 }}>
                    <Typography variant="h5"  component="div">
                        Политика конфеденциальности
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={()=>{setOpenPrivacyPolicy(false)}}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <PrivacyPolicy/>
                </DialogContent>
            </Dialog>
        </ThemeProvider>
    );
}
